import { DEFAULT_LANGUAGE_CODES } from '../constants'

export const getPrioritisedLanguage = (projectLanguages):string | undefined  => {
  return DEFAULT_LANGUAGE_CODES.find((isoCode) => projectLanguages.some((language) => language.isoCode === isoCode))
}
